import { FieldErrors } from "react-hook-form";
import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import ClearCrossButton from "../../components/ClearCrossButton";
import React from "react";

function handleEndAdornment(
    errors: FieldErrors,
    name: string,
    setValue: (fieldName: any, value: string) => void,
    inputRef: React.RefObject<HTMLInputElement>,
    disabled?: boolean
) {
    if (errors[name]) {
        return <ErrorOutlinedIcon style={{ color: "red" }} />
    } else {
        return disabled ? null : (
            <ClearCrossButton
                handleClear={() => {
                    setValue(name, "");
                    inputRef.current?.focus();
                }}
            ></ClearCrossButton>
        );
    }
}

export {
    handleEndAdornment
}
